import script from "./AuthLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AuthLayout.vue?vue&type=style&index=0&id=5cfec3b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfec3b8"]])

export default __exports__